import CustomButton from "Components/Custom/CustomButton";
import Icon, { IconName } from "Components/Icons/Icon";
import React from "react";

interface PageHeaderActionsProps {
  title: string;
  subtitle: string;
  btnLabel: string;
  onClick?: () => void;
  onInfoClick?: () => void;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  icon?: IconName;
  isInfo?: boolean;
  isDefaultBtn?: boolean;
  tagline?: string;
  loading?: boolean;
  disabled?: boolean;
}

const PagePlanHeader = ({
  title,
  subtitle,
  onClick,
  btnLabel,
  leftIcon,
  rightIcon,
  icon,
  isInfo,
  isDefaultBtn = true,
  tagline,
  onInfoClick,
  loading = false,
  disabled = false,
}: PageHeaderActionsProps) => {
  const btnClass = isDefaultBtn
    ? "bg-primary br-7 align-items-center justify-content-center gap-2"
    : "br-7 border-1 border-primary bg-white align-items-center justify-content-center gap-2";

  const textClass = isDefaultBtn ? "text-white" : "text-primary";

  return (
    <div className="d-flex flex-column bg-white p-3 br-10 gap-2 mb-3">
      {/* Responsive Top Section */}
      <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
        {/* Left: Icon + Title */}
        <div className="d-flex align-items-center gap-3">
          {icon && (
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title fs-3 text-primary bg-light br-7">
                <Icon name={icon} />
              </span>
            </div>
          )}

          <div className="d-flex align-items-center gap-2">
            <p className="text-black2D fs-20 fw-medium font-primary m-0">
              {title}
            </p>

            {isInfo && (
              <i
                className="ri-error-warning-line text-black2D"
                style={{ fontSize: 18 }}
                onClick={onInfoClick}
              />
            )}
          </div>
        </div>

        {/* Right: Button */}
        <CustomButton
          text={btnLabel}
          newClassName={btnClass}
          leftIcon={leftIcon}
          rightIcon={rightIcon}
          onClick={onClick}
          textClassName={textClass}
          loading={loading}
          disabled={disabled}
        />
      </div>

      {/* Subtitle */}
      <p className="text-grey89 fs-14 fw-medium font-primary mt-2 mb-0">
        {subtitle}
      </p>
      {tagline && (
        <p className="text-grey89 fs-14 fw-medium font-primary mt-2 mb-0">
          {tagline}
        </p>
      )}
    </div>
  );
};

export default PagePlanHeader;
